module.exports = __webpack_public_path__ + "img/hero_portrait_sm-min.d4843227.png";